<template>
	<div class="header">
		<div class="container-fluid">
			<div class="header-row" :class="{ 'header-row_centered': centered }">
				<div class="logo" :class="`logo_theme_${theme}`">
					<img :src="logoSrc" alt="Simple App" />
				</div>
				<div class="right-col">
					<slot name="rightCol"></slot>
				</div>
				<div v-if="$slots.coins">
					<slot name="coins"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import logoWhite from '@/assets/logos/logo-white-inline.svg'
import logoGray from '@/assets/logos/logo-gray-inline.svg'
import logoPrimary from '@/assets/logos/logo-primary-inline.svg'
import logoMove from '@/assets/logos/logo-move.svg'

export default {
	name: 'BaseHeader',

	props: {
		theme: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'white', 'gray', 'move'].includes(value),
		},

		centered: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		logoSrc() {
			if (this.theme === 'white') {
				return logoWhite
			} else if (this.theme === 'gray') {
				return logoGray
			} else if (this.theme === 'move') {
				return logoMove
			}

			return logoPrimary
		},
	},
}
</script>

<style scoped lang="scss">
.header {
	width: 100%;

	&-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;

		&.header-row_centered {
			justify-content: center;
		}
	}

	.right-col {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.logo {
		img {
			height: var(--size-26);
		}

		&_theme_move img {
			height: var(--size-20);
		}
	}
}
</style>
